import { render, staticRenderFns } from "./RadioOption.vue?vue&type=template&id=e53a1b26&"
import script from "./RadioOption.vue?vue&type=script&lang=ts&"
export * from "./RadioOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports